<template>
  <div class="decision-suggestion-card">
    <div class="ds-header">
      <div class="ds-title">{{ title }}</div>
    </div>
    <div class="ds-list">
      <div v-for="(item, idx) in parsedSuggestions" :key="idx" class="ds-item">
        <div class="ds-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
        </div>
        <div class="ds-content">
          <div class="ds-name">{{ item.title }}</div>
          <div class="ds-desc" v-if="item.description">{{ item.description }}</div>
        </div>
        <div class="ds-duration" v-if="item.duration">{{ item.duration }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DecisionSuggestion',
  props: {
    title: { type: String, default: '' },
    suggestions: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedSuggestions() {
      if (Array.isArray(this.suggestions)) return this.suggestions
      if (typeof this.suggestions === 'string') {
        try {
          const parsed = JSON.parse(this.suggestions)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.decision-suggestion-card {
  max-width: 800px;
  padding: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.ds-header {
  padding: 16px 20px 12px;
}

.ds-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.ds-list {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ds-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: #F7F8FC;
  border-radius: 8px;
}

.ds-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  background: #4e8cff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.ds-content {
  flex: 1;
  min-width: 0;
}

.ds-name {
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.5;
  margin-bottom: 4px;
}

.ds-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.6;
}

.ds-duration {
  flex-shrink: 0;
  padding: 2px 8px;
  background: #eef3ff;
  color: #4e8cff;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 1.5;
}
</style>
